import React from "react";
import withSizePositionAngle from "components/withSizePositionAngle";


const _Soepkommetje = () => {
    return (
        <g transform="translate(-80.269317 -161.672620)">
          <g>
            <path fill="#ffffff" stroke="#333333" strokeWidth="1.058" strokeLinecap="round" stopColor="#000000" strokeDasharray="none" strokeLinejoin="round" d="m 106.90035,178.20026 a 13.315515,10.913822 0 0 1 -6.65776,9.45164 13.315515,10.913822 0 0 1 -13.315516,0 13.315515,10.913822 0 0 1 -6.657757,-9.45164 h 13.315514 z"/>
            <g transform="translate(-1.19931, 0)">
              <path fill="none" stroke="#b3b3b3" strokeWidth="0.529167" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="m 99.017471,161.67262 c 0,0 3.272149,3.24065 0,6.51279 -3.272143,3.27214 0,6.51279 0,6.51279" />
              <path fill="none" stroke="#b3b3b3" strokeWidth="0.529167" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="m 94.784138,161.67262 c 0,0 3.27214,3.24065 0,6.51279 -3.272143,3.27214 0,6.51279 0,6.51279" />
              <path fill="none" stroke="#b3b3b3" strokeWidth="0.529167" strokeLinecap="round" strokeLinejoin="miter" strokeDasharray="none" strokeOpacity="1" d="m 91.079972,161.67262 c 0,0 3.27214,3.24065 0,6.51279 -3.272143,3.27214 0,6.51279 0,6.51279" />
            </g>
          </g>
        </g>
    );
}

const Soepkommetje = withSizePositionAngle(_Soepkommetje, 26.631033, 27.441455);

export default Soepkommetje;